import { OfferTypeEnum } from "domain/offerType";
import { ContractType } from "domain/contract";
import { OrderType } from "domain/orderType";
import offerTypeHelper from "domain/offerTypeHelper";
import contractTypeHelper from "domain/contractTypeHelper";
import { localizeOfferContract as localize, localizeCommon } from "features/localization/localizeService";
import { isGuid } from "common/strings";

export function truncateText(text: string, maxLength: number) {
    if (text == null) return null;

    if (text.length < maxLength) return text;

    return text.slice(0, maxLength) + "...";
}

export function truncateGuid(text: string) {
    return isGuid(text) ? truncateText(text, 4) : text;
}

export function getPriceLabelForOffer(type: Nullish<OfferTypeEnum>, orderType: Nullish<OrderType>) {
    if (orderType === OrderType.Tas) {
        return localize("Strings_Value_TasPrice");
    }
    else if (([OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice, OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis] as Nullish<OfferTypeEnum>[]).includes(type))
        return localize("Strings_Value_CashPrice");
    else if (offerTypeHelper.isHta(type) || type === OfferTypeEnum.BushelOnlyContract)
        return localize("Strings_Value_FuturesPrice");
    else
        return localize("Strings_Value_Price");
}

export function getPriceLabelForContract(type: ContractType) {
    if (contractTypeHelper.isCash(type))
        return localize("Strings_Value_CashPrice");
    else if (contractTypeHelper.isHta(type) || type === ContractType.BushelOnly)
        return localize("Strings_Value_FuturesPrice");
    else
        return localize("Strings_Value_Price");
}

export function isErpIdSyncing(erpDisplayId: string): boolean {
    return erpDisplayId === "Syncing";
}

export function formatOrderDisplayId(value: string): string {
    if (value != null && value.length > 10)
        return value.slice(-10);

    return value;
}

export function formatHedgeCustomerWillSell(value: boolean): string {
    if (value == null) return "";
    return value ? localizeCommon("CustomerWillSell_Sell") : localizeCommon("CustomerWillSell_Buy");
}

export function formatInitials(name: string | null, firstName?: Nullish<string>, lastName?: Nullish<string>): string {
    if (firstName != null && firstName.length > 0 && lastName != null && lastName.length > 0) {
        // if first and last name provided, use those
        return `${firstName[0]}${lastName[0]}`;
    } else if (name == null || name.length === 0) {
        // return empty string if name is null or empty
        return '';
    } else {
        // otherwise get initials based on whitespace
        return name?.split(/ +/g).map((s) => s[0]).filter(Boolean).join("");
    }
}

//Yes, there are packages out there that do this, but they're bloated with irregular rules
const irregularPluralizations: { [index: string]: string } = {
    //example
    //goose: "geese"
}
export function pluralize(count: number, text: string, excludeNumber?: boolean) {

    if (count === 1) return excludeNumber
        ? text
        : `1 ${text}`;

    text = irregularPluralizations[text] ?? `${text}s`;

    if (excludeNumber) return text;

    return `${count} ${text}`;
}